import { render, staticRenderFns } from "./carMale.vue?vue&type=template&id=0647a0ae&scoped=true&"
import script from "./carMale.vue?vue&type=script&lang=js&"
export * from "./carMale.vue?vue&type=script&lang=js&"
import style0 from "./carMale.vue?vue&type=style&index=0&id=0647a0ae&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0647a0ae",
  null
  
)

export default component.exports